module.exports = __webpack_public_path__ + "static/plc-bg2-d469f154715db716faaa9b83c92a4b09.svg";